<template>
  <div class="dashboard scale-in">
    <header class="page-header" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 1rem;">
      <div>
        <h1 class="title">Boshqaruv Paneli</h1>
        <p class="text-muted">Daromadlar va e'lonlar statistikasi (Chop etilgan vaqti bo'yicha)</p>
      </div>
      
      <div class="filter-controls" style="display: flex; gap: 0.5rem; align-items: center; flex-wrap: wrap;">
        <button 
          v-for="f in predefinedFilters" 
          :key="f.value"
          @click="selectFilter(f.value)"
          class="btn"
          :class="activeFilter === f.value ? 'btn-primary' : 'btn-glass'"
        >
          {{ f.label }}
        </button>
        
        <div class="custom-date glass-panel" style="display: flex; gap: 0.5rem; padding: 0.25rem 0.5rem; border-radius: 8px; align-items: center;">
          <input type="date" v-model="startDate" style="background: transparent; border: none; color: var(--text-color); outline: none;">
          <span style="color: var(--text-muted)">-</span>
          <input type="date" v-model="endDate" style="background: transparent; border: none; color: var(--text-color); outline: none;">
          <button class="btn btn-sm" style="background: var(--primary-color); color: white; padding: 4px 8px; font-size: 0.8rem;" @click="applyCustomDate">Tasdiq</button>
        </div>
      </div>
    </header>

    <!-- Scorecards -->
    <div class="stats-grid">
      <div class="stat-card glass-panel" style="border-left: 4px solid #10b981;">
        <div class="stat-icon" style="background: rgba(16, 185, 129, 0.2); color: #10b981;">
          💰
        </div>
        <div class="stat-info">
          <p class="text-muted">Aniq to'langan summa</p>
          <h3 style="font-size: 1.5rem;">{{ formatMoney(stats.totals.actual_revenue) }} so'm</h3>
        </div>
      </div>

      <div class="stat-card glass-panel" style="border-left: 4px solid #8b5cf6;">
        <div class="stat-icon" style="background: rgba(139, 92, 246, 0.2); color: #8b5cf6;">
          📈
        </div>
        <div class="stat-info">
          <p class="text-muted">Asl kutilgan summa</p>
          <h3 style="font-size: 1.5rem;">{{ formatMoney(stats.totals.expected_revenue) }} so'm</h3>
        </div>
      </div>

      <div class="stat-card glass-panel" style="border-left: 4px solid #f59e0b;">
        <div class="stat-icon" style="background: rgba(245, 158, 11, 0.2); color: #f59e0b;">
          📊
        </div>
        <div class="stat-info">
          <p class="text-muted">Chop etilgan e'lonlar</p>
          <h3 style="font-size: 1.5rem;">{{ stats.totals.total_approved }} ta</h3>
        </div>
      </div>

      <div class="stat-card glass-panel" style="border-left: 4px solid #ef4444;">
        <div class="stat-icon" style="background: rgba(239, 68, 68, 0.2); color: #ef4444;">
          ✂️
        </div>
        <div class="stat-info">
          <p class="text-muted">Chegirmali to'lovlar</p>
          <h3 style="font-size: 1.5rem;">{{ stats.totals.reduced_payments }} ta holat</h3>
        </div>
      </div>
    </div>
    
    <!-- Charts Section -->
    <div class="charts-wrap">
      
      <!-- Line Chart -->
      <div class="chart-box glass-panel main-chart">
        <h3 style="margin-bottom: 1rem;">O'sish dinamikasi (Kunlik)</h3>
        <div v-if="stats.daily_stats.length === 0" class="text-muted text-center py-4">Hozircha ma'lumot yo'q</div>
        <div style="height: 300px; width: 100%;" v-else>
          <Line :data="lineData" :options="lineOptions" />
        </div>
      </div>

      <!-- Donut Chart Categories -->
      <div class="chart-box glass-panel side-chart">
        <h3 style="margin-bottom: 1rem;">E'lon Toifalari</h3>
        <div v-if="stats.categories.length === 0" class="text-muted text-center py-4">Hozircha ma'lumot yo'q</div>
        <div style="height: 250px; width: 100%; display: flex; justify-content: center;" v-else>
          <Doughnut :data="pieData" :options="pieOptions" />
        </div>
      </div>

      <!-- Donut Chart Tariffs -->
      <div class="chart-box glass-panel side-chart">
        <h3 style="margin-bottom: 1rem;">E'lon Turlari (Ta'rif)</h3>
        <div v-if="stats.tariffs.oddiy.count === 0 && stats.tariffs.tezkor.count === 0" class="text-muted text-center py-4">Hozircha ma'lumot yo'q</div>
        <div style="height: 250px; width: 100%; display: flex; justify-content: center;" v-else>
          <Doughnut :data="tariffData" :options="pieOptions" />
        </div>
      </div>

    </div>

    <!-- Reduced Payments Datatable -->
    <div class="glass-panel" style="margin-top: 1.5rem;" v-if="stats.reduced_details.length > 0">
      <div class="panel-header" style="padding: 1rem; border-bottom: 1px solid var(--glass-border);">
        <h3 style="color: #ef4444;">⚠️ Kamroq to'langan holatlar ro'yxati</h3>
      </div>
      <div class="table-responsive" style="padding: 1rem;">
        <table class="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Sana</th>
              <th>Baho (Asl)</th>
              <th>To'langan</th>
              <th>Farq (Zarar)</th>
              <th>Sabab / Izoh</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="rd in stats.reduced_details" :key="rd.id">
              <td>#{{ rd.id }}</td>
              <td>{{ formatDate(rd.publish_date) }}</td>
              <td style="color: #8b5cf6;">{{ formatMoney(rd.price) }} so'm</td>
              <td style="color: #10b981; font-weight: bold;">{{ formatMoney(rd.paid_amount) }} so'm</td>
              <td style="color: #ef4444;">{{ formatMoney(rd.price - rd.paid_amount) }} so'm</td>
              <td><i>{{ rd.payment_note || 'Izoh yozilmagan' }}</i></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  ArcElement,
  BarElement
} from 'chart.js'
import { Line, Doughnut } from 'vue-chartjs'
import { authFetch } from '../utils/api'

ChartJS.register(
  CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ArcElement, BarElement)

export default {
  name: 'DashboardView',
  components: { Line, Doughnut },
  data() {
    return {
      activeFilter: 'all_time',
      startDate: '',
      endDate: '',
      predefinedFilters: [
        { label: 'Barcha vaqt', value: 'all_time' },
        { label: 'Bugun', value: 'today' },
        { label: 'Oxirgi 7 kun', value: 'last_7' },
        { label: 'Shu oy', value: 'this_month' }
      ],
      stats: {
        totals: {
          total_approved: 0,
          expected_revenue: 0,
          actual_revenue: 0,
          reduced_payments: 0,
          total_announcements_created: 0
        },
        daily_stats: [],
        categories: [],
        tariffs: { oddiy: { count: 0, revenue: 0 }, tezkor: { count: 0, revenue: 0 } },
        reduced_details: []
      },
      chartColors: [
        '#3b82f6', '#8b5cf6', '#10b981', '#f59e0b', '#ef4444', 
        '#ec4899', '#06b6d4', '#84cc16', '#64748b'
      ],
      lineOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'top', labels: { color: '#cbd5e1' } },
          tooltip: { mode: 'index', intersect: false }
        },
        scales: {
          y: {
            type: 'linear',
            display: true,
            position: 'left',
            grid: { color: 'rgba(255, 255, 255, 0.1)' },
            ticks: { color: '#94a3b8' }
          },
          y1: {
            type: 'linear',
            display: true,
            position: 'right',
            grid: { drawOnChartArea: false },
            ticks: { color: '#94a3b8' }
          },
          x: {
            grid: { color: 'rgba(255, 255, 255, 0.1)' },
            ticks: { color: '#94a3b8' }
          }
        }
      },
      pieOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'right', labels: { color: '#cbd5e1' } }
        }
      }
    }
  },
  computed: {
    lineData() {
      return {
        labels: this.stats.daily_stats.map(s => this.formatDate(s.date)),
        datasets: [
          {
            label: 'Tushum (so\'m)',
            data: this.stats.daily_stats.map(s => s.daily_revenue),
            borderColor: '#10b981',
            backgroundColor: 'rgba(16, 185, 129, 0.1)',
            tension: 0.4,
            fill: true,
            yAxisID: 'y'
          },
          {
            label: 'E\'lonlar soni',
            data: this.stats.daily_stats.map(s => s.ads_count),
            borderColor: '#3b82f6',
            backgroundColor: 'transparent',
            borderDash: [5, 5],
            tension: 0.4,
            yAxisID: 'y1'
          }
        ]
      }
    },
    pieData() {
      return {
        labels: this.stats.categories.map(c => `${c.category} (${c.count} ta)`),
        datasets: [{
          data: this.stats.categories.map(c => c.revenue),
          backgroundColor: this.chartColors.slice(0, this.stats.categories.length),
          borderWidth: 0
        }]
      }
    },
    tariffData() {
      // Create chart comparing Oddiy vs Tezkor
      const oddiy = this.stats.tariffs.oddiy;
      const tezkor = this.stats.tariffs.tezkor;
      return {
        labels: [
          `Oddiy - ${oddiy.count} ta`,
          `Tezkor - ${tezkor.count} ta`
        ],
        datasets: [{
          data: [oddiy.revenue, tezkor.revenue],
          backgroundColor: ['#3b82f6', '#f59e0b'],
          borderWidth: 0
        }]
      }
    }
  },
  created() {
    this.selectFilter('all_time');
  },
  methods: {
    formatMoney(val) {
      if(!val) return 0;
      return val.toLocaleString('ru-RU');
    },
    formatDate(dateStr) {
      if(!dateStr) return '';
      // We assume dateStr is YYYY-MM-DD
      const parts = dateStr.split('-');
      if(parts.length === 3) {
        return `${parts[2]}.${parts[1]}.${parts[0].substring(2)}`;
      }
      return dateStr;
    },
    selectFilter(val) {
      this.activeFilter = val;
      const today = new Date();
      
      const formatObj = (d) => {
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${d.getFullYear()}-${mm}-${dd}`;
      };

      if (val === 'all_time') {
        this.startDate = '';
        this.endDate = '';
      } else if (val === 'today') {
        const d = formatObj(today);
        this.startDate = d;
        this.endDate = d;
      } else if (val === 'last_7') {
        const dEnd = formatObj(today);
        const past = new Date(today.getTime() - (6 * 24 * 60 * 60 * 1000));
        const dStart = formatObj(past);
        this.startDate = dStart;
        this.endDate = dEnd;
      } else if (val === 'this_month') {
        const dStart = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-01`;
        this.startDate = dStart;
        this.endDate = formatObj(today);
      }
      
      this.fetchStats();
    },
    applyCustomDate() {
      this.activeFilter = 'custom';
      this.fetchStats();
    },
    async fetchStats() {
      let query = '';
      if(this.startDate) query += `start_date=${this.startDate}`;
      if(this.endDate) query += (query ? '&' : '') + `end_date=${this.endDate}`;
      
      try {
        const res = await authFetch(`/api/dashboard/stats?${query}`);
        this.stats = await res.json();
      } catch (e) {
        console.error("Stats fetch error", e);
      }
    }
  }
}
</script>

<style scoped>
.page-header {
  margin-bottom: 2rem;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.stat-card {
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1.25rem;
  transition: transform 0.2s ease;
}

.stat-card:hover {
  transform: translateY(-3px);
}

.stat-icon {
  width: 54px;
  height: 54px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.stat-info h3 {
  margin-bottom: 0.25rem;
  color: var(--text-color);
}

.charts-wrap {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 1.5rem;
}

.chart-box {
  padding: 1.5rem;
}

@media (max-width: 900px) {
  .charts-wrap {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
}

.table-container {
  scrollbar-color: var(--glass-border) transparent;
  scrollbar-width: thin;
}
.data-table th, .data-table td {
  padding: 0.75rem 1rem;
  text-align: left;
  border-bottom: 1px solid rgba(255,255,255,0.05);
  white-space: nowrap;
}
.data-table th {
  color: var(--text-muted);
  font-weight: 500;
  font-size: 0.85rem;
  text-transform: uppercase;
}

.scale-in {
  animation: scaleIn 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes scaleIn {
  from { opacity: 0; transform: scale(0.98); }
  to { opacity: 1; transform: scale(1); }
}
</style>
